const Radio = ({ element, value = '', onChange }) => {
    var placetext = element.placeholder !== undefined ? element.placeholder : '0';
    return <input type="number" className="masiveData" placeholder={placetext} name={element.id} value={value} onChange={(e) => onChange(e.target.value)} />
}

export default Radio;